const announcementCard = document.querySelector('.carte-annonce-flottante');
const closeButton = announcementCard.querySelector('.carte-annonce-flottante__close');
const buttonsToObserve = document.querySelectorAll('.rich-text__buttons, .banner__buttons');

// Hide the card for X hours

function hideCardAndSaveTime() {
  announcementCard.classList.remove('active');
  const timeLimitInHours = announcementCard.getAttribute('data-time-limit');
  const nextDisplayTime = Date.now() + timeLimitInHours * 3600000;
  localStorage.setItem('nextDisplayTime', nextDisplayTime.toString());
}
function shouldDisplayCard() {
  const nextDisplayTime = localStorage.getItem('nextDisplayTime');
  return !nextDisplayTime || Date.now() > parseInt(nextDisplayTime);
}
closeButton.addEventListener('click', function () {
  hideCardAndSaveTime();
  announcementCard.classList.remove('active');
});
function isMobile() {
  return window.matchMedia("(max-width: 767px)").matches;
}
function elementInViewportCustom(el) {
  var top = el?.offsetTop;
  var height = el?.offsetHeight;
  while (el?.offsetParent) {
    el = el?.offsetParent;
    top += el?.offsetTop;
  }
  return top < window.pageYOffset + window.innerHeight && top + height > window.pageYOffset;
}
function handleVisibility() {
  const footer = document.getElementsByTagName('footer')[0];
  const isFooterVisible = elementInViewportCustom(footer);
  if (shouldDisplayCard() && window.scrollY > 100 && !isFooterVisible) {
    announcementCard.classList.add('active');
  } else {
    announcementCard.classList.remove('active');
  }
}
function handleMobileObserver() {
  if (isMobile()) {
    window.addEventListener('scroll', handleVisibility);
    handleVisibility();
  } else {
    window.removeEventListener('scroll', handleVisibility);
    if (shouldDisplayCard()) {
      announcementCard.classList.add('active');
    }
  }
}
handleMobileObserver();
window.addEventListener('resize', handleMobileObserver);